<template>
  <div class="editBG pt-0 mt-4">

    <v-toolbar
      tabs
      color="white"
      class="elevation-1 mt-0"
    >
      <!-- style="top: 155px; position: fixed; z-index: 1" -->
      <h4 class="pl-3 headline font-weight-light">
        My CMS settings
      </h4>
      <v-spacer></v-spacer>

      <v-btn small icon class="mr-3" @click="$router.go(-1)" right>
        <v-icon small>close</v-icon>
      </v-btn>
      <v-btn icon small :disabled="!valid" @click="save" right>
        <v-icon small>save</v-icon>
      </v-btn>
    </v-toolbar>
    
    <v-form v-model="valid" ref="form" lazy-validation>
    <v-card class="editBG elevation-0 px-2">
      <!-- <v-layout
        class="row wrap xs12 ml-3 mr-4 pl-1 mt-4 pt-5 pr-4"
        style="top:155px; z-index: 1;"
      >      
      <v-card color="grey lighten-4" flat> -->
        <v-card-text>
          <v-container fluid>
            <v-layout row wrap>
              <v-flex xs12>
                <v-select
                  v-bind:items="links"
                  v-model="after_login_page"
                  label="Where to go after login?"
                ></v-select>
              </v-flex>
            </v-layout>
          </v-container>

          <v-container fluid>            
            <v-layout row wrap>
              <v-flex xs12>
                <v-checkbox
                  label="Remember saved artworks accross sessions"
                  v-model="remember_saved_artworks"
                ></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <section-header text="Artwork Fields Shown in Collections" class="mx-4"></section-header>

          <v-flex xs12 px-0>
            <v-container fluid pa-0 ma-0 grid-list-xs text-xs-left>
              <v-layout row wrap pa-0 ma-0 class="grey lighten-2 pb-4">
                <v-flex
                  v-for="r in constants.ARTWORK_FIELDS"
                  :key="r"
                  :class="{
                    xs12: r.header || r.divider,
                    'xs12 sm6 md4 lg3': !(r.header || r.divider),
                    'px-2 py-0 my-0': true
                  }"
                >
                  <!-- <v-container fluid pa-0 ma-0>
                    <v-layout row wrap pa-0 ma-0> -->
                  <v-flex xs12 pt-3 pl-3 pb-0 mb-0 mt-4 v-if="r.header || r.divider">
                    <h2>
                      <span>{{ r.header }}</span>
                      <!-- <v-spacer></v-spacer> -->
                      <v-btn v-if="r.image" @click="showHelp(r.image)" class="right mt-0 pt-0 pb-2" icon> <v-icon color="grey darken-1">help</v-icon> </v-btn>
                    </h2>
                    <v-divider class="py-0 my-0"></v-divider>
                  </v-flex>
                  <v-flex xs12 py-0 pt-0 my-0 pl-3 v-else >
                    <!-- :disabled="roles_array.includes(2) && [1,17,18,19,20,21,22,31,32,40,41].includes(r.id)" -->
                    <v-checkbox
                      @change="remove(r)"
                      v-model="collections_field_array"
                      color=""
                      :label="r"
                      :value="r"
                      hide-details
                    ></v-checkbox>
                  </v-flex>
                  <!-- </v-layout>
                  </v-container> -->
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>        
      </v-card>

      <!-- <v-select
        label="Item"
        v-model="select"
        :items="items"
        :rules="[v => !!v || 'Item is required']"
        required
      ></v-select> -->
        <!-- :rules="[v => !!v || 'You must agree to continue!']" -->
        <!-- required -->

                    <!-- </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>  -->
                         <!-- <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.upload" label="Upload" color="black" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.download" label="Download" color="black" hide-details></v-checkbox>
            </v-flex> -->

            <!-- <v-flex xs12 mt-5 pl-3>
              <h4>Access to artworks</h4>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.pacFvh" label="Private Art Collection FTB" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>                
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.pdcFvh" label="Private Design Collection FTB" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>                
            <v-flex xs12 sm6 md4 lg4 pl-3>
              <v-checkbox v-model="userFormData.pacMr" label="Private Art Collection MR" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>                
            <v-flex xs12 sm6 md4 lg4 pl-3>
              <v-checkbox v-model="userFormData.deaccession" label="Deaccession" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>                
            <v-flex xs12 sm6 md4 lg4 pl-3>
              <v-checkbox v-model="userFormData.oldMasters" label="Old Masters" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>                
            <v-flex xs12 sm6 md4 lg4 pl-3>
              <v-checkbox v-model="userFormData.foreign" label="Foreign Artworks" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>                

            <v-flex xs12 mt-5 pl-3>
              <h4>Access to Sections</h4>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.advanced" label="Advanced" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.acquisition" label="Acquisition" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.texts" label="Texts" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.images" label="Images" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.history" label="History" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.timeline" label="Timeline" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.packings" label="Packings" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.todos" label="Todos" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.tags" label="Tags" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm6 md4 pl-3>
              <v-checkbox v-model="userFormData.conservation" label="Conservation" color="black" class="black--text dark" hide-details></v-checkbox>
            </v-flex> -->

      <v-btn
        @click="submit"
        :disabled="!valid"
      >
        save changes
      </v-btn>
      <!-- <v-btn @click="clear">clear</v-btn> -->
    </v-form>

  </div>
</template>

<script>
  import axios from '@/utils/apiClient'
  import constants from '@/data/constants';
  import SectionHeader from '@/components/layout/SectionHeader.vue';
  export default {
    data: () => ({
      collections_field_array: [],
      constants: constants,
      valid: true,
      after_login_page: '',
      remember_saved_artworks: false
      // links: Object.keys(ownerships).map(e => (ownerships[e])).concat(['Artists','Contacts'])
    }),
    methods: {
      save() {},
      submit () {
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          axios.post('/api/submit', {
            new_artwork_added: this.new_artwork_added,
            new_artist_added: this.new_artist_added,
            artwork_modified: this.artwork_modified,
            artist_modified: this.artist_modified
          })
        }
      },
      clear () {
        this.$refs.form.reset()
      }
    },
    computed: {
      // artwork_fields () {
      //   var o = this.$store.state.artworks.first
      //   return o ? o.keys : []
      // },
      formatted_roles () {
        return []
      },
      links () {
        var o = constants.OWNERSHIPS;
        var out = Object.keys(o).map(e => (o[e]))
        var out = o.map(o => (o.name))
        out.concat(['Artists', 'Contacts'])
        out.push('Lists')
        return out
      }
    },
    components: { SectionHeader }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/users/SettingsHome.vue